import React, { Component } from "react";
import { connect } from "react-redux";

import PageContent from "../PageContent";
import { go } from "../../logic/actions/navigation";
import { VALIDATE_PHONE } from "../../logic/enums/pages";

export class PageSentToMobile extends Component {
  constructor(props) {
    super(props);
    this.goBack.bind(this);
  }

  goBack = () => {
    this.props.go(VALIDATE_PHONE);
  };

  render() {
    return (
      <PageContent>
        <h1>An SMS has been sent to mobile with a link</h1>
        <p className="center">
          If you haven't received the SMS message,{" "}
          <button className="button-link" onClick={this.goBack}>
            click here to try again
          </button>
        </p>
      </PageContent>
    );
  }
}

export default connect(null, { go })(PageSentToMobile);
